import React from "react";
import { formatZAR } from "../../services/plans";

interface Row { label: string; value: number; sub?: string }

export function HorizontalBars({ rows, format = "zar" }: { rows: Row[]; format?: "zar" | "number" }) {
  if (rows.length === 0) {
    return <div className="empty-state" style={{ padding: 24 }}><h3>No data</h3></div>;
  }
  const max = Math.max(1, ...rows.map((r) => r.value));
  return (
    <div className="col" style={{ gap: 10 }}>
      {rows.map((r, i) => {
        const pct = (r.value / max) * 100;
        return (
          <div key={r.label + i} className="row" style={{ gap: 12 }}>
            <div style={{ minWidth: 160, maxWidth: 220, flexShrink: 0 }}>
              <div style={{ color: "var(--text)", fontSize: 13, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {r.label}
              </div>
              {r.sub && <div className="muted" style={{ fontSize: 11 }}>{r.sub}</div>}
            </div>
            <div className="meter" style={{ flex: 1, height: 12 }}>
              <span style={{ width: `${pct}%` }} />
            </div>
            <div className="tnum" style={{ minWidth: 90, textAlign: "right", color: "var(--text)", fontWeight: 600 }}>
              {format === "zar" ? formatZAR(r.value) : Intl.NumberFormat("en-ZA").format(r.value)}
            </div>
          </div>
        );
      })}
    </div>
  );
}
